import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "./SearchBar";

export default function Navbar() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Close dropdown when route changes
  useEffect(() => {
    setActiveDropdown(null);
  }, [location]);

  // Handle Products click on mobile
  const handleProductsClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setActiveDropdown(activeDropdown === 'products' ? null : 'products');
    }
  };

  const menuItems = {
    products: {
      title: "Products",
      link: "/products",
      categories: [
        {
          name: "Mobile & Tablets",
          items: [
            { name: "Galaxy S Series", link: "/products?category=mobiles&series=s" },
            { name: "Galaxy A Series", link: "/products?category=mobiles&series=a" },
            { name: "Tablets", link: "/products?category=tablets" },
            { name: "View All Mobiles", link: "/products?category=mobiles" }
          ]
        },
        {
          name: "TV & Audio",
          items: [
            { name: "QLED TVs", link: "/products?category=leds&type=qled" },
            { name: "OLED TVs", link: "/products?category=leds&type=oled" },
            { name: "Soundbars", link: "/products?category=soundbars" },
            { name: "View All TVs", link: "/products?category=leds" }
          ]
        },
        {
          name: "Appliances",
          items: [
            { name: "Refrigerators", link: "/products?category=homeAppliances&type=refrigerator" },
            { name: "Washing Machines", link: "/products?category=homeAppliances&type=washing" },
            { name: "View All Appliances", link: "/products?category=homeAppliances" }
          ]
        },
        {
          name: "Wearables",
          items: [
            { name: "Galaxy Watch", link: "/products?category=watches" },
            { name: "Galaxy Buds", link: "/products?category=earbuds" },
            { name: "View All Wearables", link: "/products?category=wearables" }
          ]
        }
      ]
    },
    about: {
      title: "About",
      link: "/about"
    },
    services: {
      title: "Services",
      link: "/services"
    },
    contact: {
      title: "Contact",
      link: "/contact"
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="nav-left">
            <Link to="/" className="logo">
              Samsung Door Step
            </Link>
            <ul className="nav-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li
                className={`nav-item-with-dropdown ${activeDropdown === 'products' ? 'dropdown-open' : ''}`}
                onMouseEnter={() => !isMobile && setActiveDropdown('products')}
                onMouseLeave={() => !isMobile && setActiveDropdown(null)}
              >
                <Link
                  to="/products"
                  onClick={handleProductsClick}
                  className={activeDropdown === 'products' ? 'active' : ''}
                >
                  Products {isMobile && <span className="dropdown-arrow">{activeDropdown === 'products' ? '▲' : '▼'}</span>}
                </Link>
                {activeDropdown === 'products' && (
                  <div className="mega-dropdown">
                    <div className="mega-dropdown-container">
                      {menuItems.products.categories.map((category, index) => (
                        <div key={index} className="dropdown-column">
                          <h4>{category.name}</h4>
                          <ul>
                            {category.items.map((item, idx) => (
                              <li key={idx}>
                                <Link to={item.link}>{item.name}</Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className="nav-icons">
            <span
              title="Search"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsSearchOpen(true)}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            </span>
          </div>
        </div>
      </nav>

      <SearchBar isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  );
}
